import store from "@/state/store";

export default [
  {
    path: "/account",
    name: "account",
    component: () => import("../views/account/index.vue"),
    meta: {
      title: "Account",
      authRequired: false,
    },
  },

  {
    path: "/account/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/account/lockscreen",
    name: "account-lockscreen",
    component: () => import("../views/account/lockscreen.vue"),
    meta: {
      title: "Account Lockscreen",
      authRequired: false,
    },
  },

  {
    path: "/account/profile",
    name: "account-profile",
    component: () => import("../views/account/profile.vue"),
    meta: {
      title: "Account Profile",
      authRequired: false,
    },
  },

  {
    path: "/account/reset-password",
    name: "account-reset-password",
    component: () => import("../views/account/reset-password.vue"),
    meta: {
      title: "Account Reset Password",
      authRequired: false,
    },
  },

  {
    path: "/account/verification-code",
    name: "account-verification-code",
    component: () => import("../views/account/verification-code.vue"),
    meta: {
      title: "Account Verification Code",
      authRequired: false,
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      authRequired: false,
      beforeResolve: (routeTo, routeFrom, next) => {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },

  {
    path: "/",
    name: "default",
    component: () => import("../views/dashboard/ecommerce/index.vue"),
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
  },

  {
    path: "/assets",
    name: "assets",
    component: () => import("../views/assets/index.vue"),
    meta: {
      title: "Assets",
      authRequired: true,
    },
  },

  {
    path: "/calendar",
    name: "calendar",
    component: () => import("../views/calendar/index.vue"),
    meta: {
      title: "Calendar",
      authRequired: true,
    },
  },

  {
    path: "/client",
    name: "client",
    component: () => import("../views/client/index.vue"),
    meta: {
      title: "Client",
      authRequired: true,
    },
  },

  {
    path: "/invoice/create",
    name: "invoice-create",
    component: () => import("../views/invoice/create.vue"),
    meta: {
      title: "Invoice Create",
      authRequired: true,
    },
  },

  {
    path: "/invoice/details",
    name: "invoice-details",
    component: () => import("../views/invoice/details.vue"),
    meta: {
      title: "Invoice Details",
      authRequired: true,
    },
  },

  {
    path: "/invoice/list",
    name: "invoice-list",
    component: () => import("../views/invoice/list.vue"),
    meta: {
      title: "Invoice List",
      authRequired: true,
    },
  },

  {
    path: "/job-description",
    name: "job-description",
    component: () => import("../views/job-description/index.vue"),
    meta: {
      title: "Job Description",
      authRequired: true,
    },
  },

  {
    path: "/job-type",
    name: "job-type",
    component: () => import("../views/job-type/index.vue"),
    meta: {
      title: "Job Type",
      authRequired: true,
    },
  },

  {
    path: "/jobs",
    name: "jobs",
    component: () => import("../views/jobs/index.vue"),
    meta: {
      title: "Jobs",
      authRequired: true,
    },
  },

  {
    path: "/jobs/pdf",
    name: "jobs-pdf",
    component: () => import("../views/jobs/pdf.vue"),
    meta: {
      title: "Jobs Pdf",
      authRequired: true,
    },
  },

  {
    path: "/jobs/view",
    name: "jobs-view",
    component: () => import("../views/jobs/view.vue"),
    meta: {
      title: "Jobs View",
      authRequired: true,
    },
  },

  {
    path: "/quote",
    name: "quote",
    component: () => import("../views/quote/index.vue"),
    meta: {
      title: "Quote",
      authRequired: true,
    },
  },

  {
    path: "/quote/details",
    name: "quote-details",
    component: () => import("../views/quote/details.vue"),
    meta: {
      title: "Quote Details",
      authRequired: true,
    },
  },

  {
    path: "/role",
    name: "role",
    component: () => import("../views/role/index.vue"),
    meta: {
      title: "Role",
      authRequired: true,
    },
  },

  {
    path: "/schedule",
    name: "schedule",
    component: () => import("../views/schedule/index.vue"),
    meta: {
      title: "Schedule",
      authRequired: true,
    },
  },

  {
    path: "/settings/general",
    name: "general",
    component: () => import("../views/settings/general/index.vue"),
    meta: {
      title: "General",
      authRequired: true,
    },
  },

  {
    path: "/sites",
    name: "sites",
    component: () => import("../views/sites/index.vue"),
    meta: {
      title: "Sites",
      authRequired: true,
    },
  },

  {
    path: "/ticket",
    name: "ticket",
    component: () => import("../views/ticket/index.vue"),
    meta: {
      title: "Ticket",
      authRequired: true,
    },
  },

  {
    path: "/ticket/view",
    name: "ticket-view",
    component: () => import("../views/ticket/view.vue"),
    meta: {
      title: "Ticket View",
      authRequired: true,
    },
  },

  {
    path: "/tracking",
    name: "tracking",
    component: () => import("../views/tracking/index.vue"),
    meta: {
      title: "Tracking",
      authRequired: true,
    },
  },

  {
    path: "/user",
    name: "user",
    component: () => import("../views/user/index.vue"),
    meta: {
      title: "User",
      authRequired: true,
    },
  },

  {
    path: "/user/view",
    name: "user-view",
    component: () => import("../views/user/view.vue"),
    meta: {
      title: "User View",
      authRequired: true,
    },
  }
];
